import request from '../utils/request';

export function getManagerList(param) {
    return request({
        url: '/admin/search-manager',
        method: 'GET',
        params: param
    })
}

export function saveManager(id, data) {
    if (id > 0) {
        return request({
            url: '/admin/manager/'+id,
            method: 'PUT',
            data
        })
    } else {
        return request({
            url: '/admin/manager',
            method: 'POST',
            data
        })
    }

}

export function SetManagerPassword(id, data) {
        return request({
            url: '/admin/manager-password/'+id,
            method: 'PUT',
            data
        })
}